/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  RemoteSessionClient,
  RemoteSessionClient$inboundSchema,
} from "./remotesessionclient.js";

/**
 * Result type for listing remote_session_clients.
 */
export type ListRemoteSessionClientsResult = {
  items: Array<RemoteSessionClient>;
  /**
   * Cursor for the next page; empty when exhausted.
   */
  nextCursor?: string | undefined;
};

/** @internal */
export const ListRemoteSessionClientsResult$inboundSchema: z.ZodMiniType<
  ListRemoteSessionClientsResult,
  unknown
> = z.pipe(
  z.object({
    items: z.array(RemoteSessionClient$inboundSchema),
    next_cursor: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "next_cursor": "nextCursor",
    });
  }),
);

export function listRemoteSessionClientsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListRemoteSessionClientsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListRemoteSessionClientsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListRemoteSessionClientsResult' from JSON`,
  );
}
